import React from 'react';
import logoOXW from '../../assets/LOGO_OXETECH_WORK.png'
import logoOXL from '../../assets/homeTriangle/oxeTechLabLogoON.png'
import logoOXD from '../../OxeTechEdu/assets/logo.svg'
import { Item, ItemTopo, LogoPrograma, PontoNaoLida, ItemTitulo, ItemDescricao } from './styles';

// O titulo chega como "Oxetech Work — Contratação em Análise". Como a logo ja
// identifica o programa, o prefixo antes do travessao sai do texto exibido.
const tituloSemPrograma = (titulo) => {
  const texto = typeof titulo === 'string' ? titulo : '';
  const partes = texto.split(' — ');
  return partes.length > 1 ? partes.slice(1).join(' — ') : texto;
};

const Notificacao = ({ id, titulo, descricao, seen }) => {
  const logoPrograma = {
    src: titulo?.includes("OxetechLAB") ? logoOXL : (titulo?.includes("Oxetech Work") ? logoOXW : logoOXD),
    alt: titulo?.includes("OxetechLAB") ? 'OxetechLAB' : (titulo?.includes("Oxetech Work") ? 'Oxetech Work' : 'Oxetech Edu')
  }
  return (
    <Item key={id} naoLida={!seen}>
      <ItemTopo>
        <LogoPrograma src={logoPrograma.src} alt={logoPrograma.alt} />
        {!seen && <PontoNaoLida aria-label="Não lida" />}
      </ItemTopo>
      <ItemTitulo>{tituloSemPrograma(titulo)}</ItemTitulo>
      {descricao && <ItemDescricao>{descricao}</ItemDescricao>}
    </Item>
  );
};


export default Notificacao;
